import React from "react";
import toast from "react-hot-toast";
import I18n from "i18n-js";

import api from "../../../api";

import Action from "./Action";

import requestIcon from "../../../assets/icons/request.svg";
import approveIcon from "../../../assets/icons/approve.svg";
import confirmIcon from "../../../assets/icons/confirm.svg";

const LeaderActions = ({ plan }) => {

  const enableRequestAction = true;
  const enableApproveAction = plan?.status === "published";
  const enableConfirmAction = plan?.status === "completed";

  const requestPlan = async () => {
    console.log(plan)
    try {
      const res = await api.post("/development_plans/req", { user_uuid: plan?.user_uuid });
      console.log(res);
      setTimeout(() => {
        toast.success(<b>{I18n.t("common.requested_successfully")}</b>);
      }, 500);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(<b>{err.response.data.message}</b>);
      } else {
        toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
      }
      console.error(err);
    }
  }

  const approvePlan = async () => {
    try {
      const res = await api.post(`/development_plans/${plan?.uuid}/approve`);
      console.log(res);
      setTimeout(() => {
        toast.success(<b>{I18n.t("common.approved_successfully")}</b>);

        if (res.data && res.data.redirect_to) {
          window.location.assign(res.data.redirect_to);
        }
      }, 500);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(<b>{err.response.data.message}</b>);
      } else {
        toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
      }
      console.error(err);
    }
  }

  const confirmPlan = async () => {
    try {
      const res = await api.post(`/development_plans/${plan?.uuid}/confirm`);
      console.log(res);
      setTimeout(() => {
        toast.success(<b>{I18n.t("common.confirmed_successfully")}</b>);
  
        if (res.data && res.data.redirect_to) {
          window.location.assign(res.data.redirect_to);
        }
      }, 500);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(<b>{err.response.data.message}</b>);
      } else {
        toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
      }
      console.error(err);
    }
  }

  return (
    <div className="leader-actions">
      <Action
        title={I18n.t("pdp.actions.plan.request")}
        icon={requestIcon}
        disabled={!enableRequestAction}
        onExecute={requestPlan}
      />
      <Action
        title={I18n.t("pdp.actions.plan.approve")}
        icon={approveIcon}
        disabled={!enableApproveAction}
        onExecute={approvePlan}
      />
      <Action
        title={I18n.t("pdp.actions.plan.confirm")}
        icon={confirmIcon}
        disabled={!enableConfirmAction}
        onExecute={confirmPlan}
      />
    </div>
  );
}

export default LeaderActions;
